export function isInteractiveTarget(event: Event): boolean {
  return (
    event.target instanceof HTMLElement &&
    !!event.target.closest('a, button, input, textarea, select, [role="button"], .p-checkbox, .p-button')
  );
}

export function getMostVisibleSectionId(container: HTMLElement, sectionIds: string[]): string | undefined {
  const containerRect = container.getBoundingClientRect();

  return sectionIds
    .map((id) => getSectionVisibility(id, containerRect))
    .filter((section): section is { id: string; visiblePercent: number } => !!section)
    .sort((a, b) => b.visiblePercent - a.visiblePercent)[0]?.id;
}

export function getTopStickyChildrenHeight(container: HTMLElement): number {
  const containerRect = container.getBoundingClientRect();
  const stickyElement = Array.from(container.children).find((child) => {
    const element = child as HTMLElement;

    return window.getComputedStyle(element).position === 'sticky';
  }) as HTMLElement | undefined;

  if (!stickyElement) {
    return 0;
  }

  const stickyRect = stickyElement.getBoundingClientRect();

  return Math.max(stickyRect.bottom - containerRect.top, 0);
}

export function waitForRender(): Promise<void> {
  return new Promise((resolve) => requestAnimationFrame(() => setTimeout(resolve)));
}

function getSectionVisibility(id: string, containerRect: DOMRect): { id: string; visiblePercent: number } | null {
  const section = document.getElementById(id);
  if (!section) return null;

  const sectionRect = section.getBoundingClientRect();
  const visibleHeight =
    Math.min(sectionRect.bottom, containerRect.bottom) - Math.max(sectionRect.top, containerRect.top);

  return {
    id,
    visiblePercent: Math.max(0, visibleHeight) / sectionRect.height,
  };
}
